import { createContext } from '@chakra-ui/react-utils';
import type { SystemStyleObject } from '@chakra-ui/system';

import type { ThinkingPart } from './types';

export type ThinkingStyles = Partial<Record<ThinkingPart, SystemStyleObject>>;

const [ThinkingStylesProvider, useThinkingStyles] =
  createContext<ThinkingStyles>({
    name: 'ThinkingStylesContext',
    strict: true,
    errorMessage:
      'useThinkingStyles: `context` is undefined. Seems you forgot to wrap all menu components within `<Thinking />`',
  });

export { ThinkingStylesProvider, useThinkingStyles };
